/**
 * @module utils
 */
/** comment to work-around limitation of typedoc module plugin */

// Copyright 2018-2024 Enlightware GmbH, Switzerland

import { bufferToHex } from 'utils/buffers';
import { createRandomUuidBuffer } from 'utils/uuid-generator';

const urlParams = new URLSearchParams(window.location.search);
const parametersJsId = urlParams.get('jsId');
const jsRuntimeId = parametersJsId ?
	parametersJsId :
	bufferToHex(createRandomUuidBuffer()); // Choosing purely random UUID to avoid risk to violate GDPR through this ID.
console.debug('JsRuntimeId =', jsRuntimeId);

export function getJsRuntimeId() {
	return jsRuntimeId;
}
